<template>
  <div>
    <app-header /> 
    <div class="not-found-wrap">
        Страница не найдена            
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";

export default {
  name: "E404",
  components: {
    "app-header": Header,
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/settings.scss";

.not-found-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 80vh;
}
</style>
